import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, defer, filter, Observable, of, shareReplay, switchMap } from 'rxjs';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class CascadingSelectServiceService {
  public departmentSubject = new BehaviorSubject<string | null>(null);
  public classSubject = new BehaviorSubject<string | null>(null);
  public batchSubject = new BehaviorSubject<string | null>(null);


  academicEntries$!: Observable<any>;
  departments$: Observable<any[]>;
  classes$!: Observable<any>;
  batches$!: Observable<any>;
  academicYear$!: Observable<any>;
  course$!: Observable<any>;
  group$!: Observable<any>;



  classesByDepartment$: Observable<any[]>;
  batchesByClass$: Observable<any[]>;

  apiUrl = environment.apiUrl

  constructor(private http: HttpClient) {
    this.departments$ = this.http.get<any>(`${this.apiUrl}department/get-all?pagination=false`).pipe(
      // expected: { status: 'success', data: [...] }
      switchMap((res: any) => of(Array.isArray(res?.data) ? res.data : [])),
      shareReplay(1)
    );

    this.classes$ = this.http.get<any[]>(`${this.apiUrl}classes`).pipe(shareReplay(1));
    this.batches$ = this.http.get<any[]>(`${this.apiUrl}batches`).pipe(shareReplay(1));
    this.course$ = this.http.get<any[]>(`${this.apiUrl}course/get-all-details?pagination=false`).pipe(shareReplay(1));
    this.group$ = this.http.get<any[]>(`${this.apiUrl}groups`).pipe(shareReplay(1));


    this.academicYear$ = this.http.get<any[]>(`${this.apiUrl}academic-years/get-all`).pipe(shareReplay(1));
    this.academicEntries$ = this.http.get<any[]>(`${this.apiUrl}departments-with-classes-batches`).pipe(shareReplay(1));



    this.classesByDepartment$ = this.departmentSubject.pipe(
      switchMap((deptId) => deptId
        ? this.http.get<any[]>(`${this.apiUrl}classes`,{params:{department_id: deptId}})
        : of([])),
      shareReplay(1)
    );

    this.batchesByClass$ = this.classSubject.pipe(
      filter(classId => classId !== null),
      switchMap(classId => this.http.get<any[]>(`${this.apiUrl}batches`,{params:{class_id: classId}})),
      shareReplay(1)
    );
  }

  setDepartment(deptId: string) {
    this.departmentSubject.next(deptId);
    this.classSubject.next(null);
    this.batchSubject.next(null);
  }

  setClass(classId: string) {
    this.classSubject.next(classId);
    this.batchSubject.next(null);
  }

  reset() {
    this.departmentSubject.next(null);
    this.classSubject.next(null);
    this.batchSubject.next(null);
  }


  get academicEntries() {
    return defer(() => this.academicEntries$);
  }

}
